import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useRef, useEffect } from 'react';

var ReactIFrame = React.forwardRef(function (_a, ref) {
    var src = _a.src, onLoad = _a.onLoad, restProps = __rest(_a, ["src", "onLoad"]);
    var internalFrameRef = useRef(null);
    React.useImperativeHandle(ref, function () { return internalFrameRef.current; });
    useEffect(function () {
        if (internalFrameRef === null || internalFrameRef === void 0 ? void 0 : internalFrameRef.current) {
            internalFrameRef.current.src = src;
        }
    }, []);
    return React.createElement("iframe", __assign({ ref: internalFrameRef, onLoad: onLoad }, restProps));
});

export { ReactIFrame as default };
//# sourceMappingURL=react-onload-iframe.browser.esm.js.map
